import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';

export const useInBriefFloatingFormPreConditions = (): boolean => {
    const sellersCountriesCodes = ['IN', 'BD', 'PK', 'ID', 'MA', 'NG', 'LK', 'KE'];

    const {
        userId,
        experience: { isBusiness },
        isMobile,
        locale,
        countryCode,
    } = getContext();

    return (
        !!userId &&
        isBusiness &&
        !isMobile &&
        locale === DEFAULT_FIVERR_LOCALE &&
        !sellersCountriesCodes.includes(countryCode)
    );
};
